/* eslint-disable @typescript-eslint/ban-types */
import { CustomFieldType, MultipleChoiceConfigOptions, RegistrationPageType, StandardFieldType } from '@shared/enums/CustomFieldType';
import { EventPageType } from '@shared/enums/EventPageType';
import { FreeTextFormat } from '@shared/enums/FreeTextFormat';
import { PageLayoutType } from '@shared/enums/PageLayoutType';
import { ILanguage } from '@shared/services/api/legacy/languages-service/languages-model';
import { CheckboxFormat } from '@shared/enums/CheckboxFormat';
import * as moment from 'moment';
import { SelectFormat } from '@shared/enums/SelectFormat';
import { ReportPeriodType } from '@shared/enums/ReportPeriodType';
import { SpeakersPageDisplayType } from '@shared/enums/SpeakersPageDisplayType';
import { WorkshopsPageDisplayType } from '@shared/enums/WorkshopsPageDisplayType';
import { ContactType } from '@shared/enums/ContactType';

export interface IEventPage {
    type: EventPageType;
    id: string;
    files: any;
    fromDate: Date;
    toDate: Date;
    showName: boolean;
    showCompany: boolean;
    showAddress: boolean;
    showEmail: boolean;
    showMobile: boolean;
    showGuestName: boolean;
    showGuestCompany: boolean;
    showGuestAddress: boolean;
    showGuestEmail: boolean;
    showGuestMobile: boolean;
    requiredName: boolean;
    requiredCompany: boolean;
    requiredAddress: boolean;
    requiredEmail: boolean;
    requiredMobile: boolean;
    requiredGuestName: boolean;
    requiredGuestCompany: boolean;
    requiredGuestAddress: boolean;
    requiredGuestEmail: boolean;
    requiredGuestMobile: boolean;
    fieldConfigurations: IFieldConfiguration[];
    customFields: ICustomField[];
    customFieldsToDelete: string[];
    customFieldOptionsToDelete: string[];
    languages: ILanguage[];
    contents: any;
    showJobTitle: boolean;
    showGuestJobTitle: boolean;
    requiredJobTitle: boolean;
    requiredGuestJobTitle: boolean;
    fieldOrders: IFieldOrder[];
    baseFieldsToDelete: string[];
    showCustomerNumber: boolean;
    requiredCustomerNumber: boolean;
    showGuestCustomerNumber: boolean;
    requiredGuestCustomerNumber: boolean;
    defaultGuests: number;
    maximumGuests: number;
    showLogo: boolean;
    showBanner: boolean;
    showDetail: boolean;
    showContact: boolean;
    routingPerVenue: boolean;
    locationDateTimeEventPageFields: ILocationDateTimeEventPageField[];
    pageLayoutType: PageLayoutType;
    titles: any;
    overrideGuests: boolean;
    toDateDays: number;
    galleryAccessType: number;
    galleryDisplayType: number;
    fieldLabels: IFieldLabel[];
    speakers: any;
    speakersPageDisplayType: SpeakersPageDisplayType;
    locationDateTimesPerGroups: any;
    workshops: any;
    workshopsPageDisplayType: WorkshopsPageDisplayType;
    overridePrivacyContent: boolean;
    eventPrivacyContents: any;
    overrideEmployeesDisclaimerContent: boolean;
    overrideBusinessRelationsDisclaimerContent: boolean;
    eventDisclaimerContents: EventDisclaimerContent[];
}

export class EventPage implements IEventPage {
    constructor(
        public type: EventPageType,
        public id: string,
        public files: any,
        public fromDate: Date,
        public toDate: Date,
        public showName: boolean,
        public showCompany: boolean,
        public showAddress: boolean,
        public showEmail: boolean,
        public showMobile: boolean,
        public showGuestName: boolean,
        public showGuestCompany: boolean,
        public showGuestAddress: boolean,
        public showGuestEmail: boolean,
        public showGuestMobile: boolean,
        public requiredName: boolean,
        public requiredCompany: boolean,
        public requiredAddress: boolean,
        public requiredEmail: boolean,
        public requiredMobile: boolean,
        public requiredGuestName: boolean,
        public requiredGuestCompany: boolean,
        public requiredGuestAddress: boolean,
        public requiredGuestEmail: boolean,
        public requiredGuestMobile: boolean,
        public fieldConfigurations: IFieldConfiguration[],
        public customFields: ICustomField[],
        public customFieldsToDelete: string[],
        public customFieldOptionsToDelete: string[],
        public languages: ILanguage[],
        public contents: any,
        public showJobTitle: boolean,
        public showGuestJobTitle: boolean,
        public requiredJobTitle: boolean,
        public requiredGuestJobTitle: boolean,
        public fieldOrders: IFieldOrder[],
        public baseFieldsToDelete: string[],
        public showCustomerNumber: boolean,
        public requiredCustomerNumber: boolean,
        public showGuestCustomerNumber: boolean,
        public requiredGuestCustomerNumber: boolean,
        public defaultGuests: number,
        public maximumGuests: number,
        public showLogo: boolean,
        public showBanner: boolean,
        public showDetail: boolean,
        public showContact: boolean,
        public routingPerVenue: boolean,
        public locationDateTimeEventPageFields: ILocationDateTimeEventPageField[],
        public pageLayoutType: PageLayoutType,
        public titles: any,
        public overrideGuests: boolean,
        public toDateDays: number,
        public galleryAccessType: number,
        public galleryDisplayType: number,
        public fieldLabels: IFieldLabel[],
        public speakers: any,
        public speakersPageDisplayType: SpeakersPageDisplayType,
        public locationDateTimesPerGroups: any,
        public workshops: any,
        public workshopsPageDisplayType: WorkshopsPageDisplayType,
        public overridePrivacyContent: boolean,
        public eventPrivacyContents: any,
        public overrideEmployeesDisclaimerContent: boolean,
        public overrideBusinessRelationsDisclaimerContent: boolean,
        public eventDisclaimerContents: EventDisclaimerContent[]
    ) { }
}

export interface IAddEventPage {
    type: EventPageType;
    fromDate: Date;
    toDate: Date;
    showName: boolean;
    showCompany: boolean;
    showAddress: boolean;
    showEmail: boolean;
    showMobile: boolean;
    showGuestName: boolean;
    showGuestCompany: boolean;
    showGuestAddress: boolean;
    showGuestEmail: boolean;
    showGuestMobile: boolean;
    requiredName: boolean;
    requiredCompany: boolean;
    requiredAddress: boolean;
    requiredEmail: boolean;
    requiredMobile: boolean;
    requiredGuestName: boolean;
    requiredGuestCompany: boolean;
    requiredGuestAddress: boolean;
    requiredGuestEmail: boolean;
    requiredGuestMobile: boolean;
    fieldConfigurations: IFieldConfiguration[];
    customFields: ICustomField[];
    languages: ILanguage[];
    contents: any;
    showJobTitle: boolean;
    showGuestJobTitle: boolean;
    requiredJobTitle: boolean;
    requiredGuestJobTitle: boolean;
    fieldOrders: IFieldOrder[];
    showCustomerNumber: boolean;
    requiredCustomerNumber: boolean;
    showGuestCustomerNumber: boolean;
    requiredGuestCustomerNumber: boolean;
    defaultGuests: number;
    maximumGuests: number;
    showLogo: boolean;
    showBanner: boolean;
    showDetail: boolean;
    showContact: boolean;
    routingPerVenue: boolean;
    locationDateTimeEventPageFields: ILocationDateTimeEventPageField[];
    pageLayoutType: PageLayoutType;
    titles: any;
    overrideGuests: boolean;
    toDateDays: number;
    overridePrivacyContent: boolean;
    eventPrivacyContents: any;
    overrideEmployeesDisclaimerContent: boolean;
    overrideBusinessRelationsDisclaimerContent: boolean;
    eventDisclaimerContents: EventDisclaimerContent[];
    // Event-level items (Speaker/Workshop/EventPageFile now live on the Event). Preloaded into the model
    // when creating a Speakers/Workshops/Gallery page so they show in the form + preview. Optional so the
    // AddEventPage class satisfies the interface without constructor changes.
    speakers?: any;
    workshops?: any;
    files?: any;
}

export class AddEventPage implements IAddEventPage {
    constructor(
        public type: EventPageType,
        public fromDate: Date,
        public toDate: Date,
        public showName: boolean,
        public showCompany: boolean,
        public showAddress: boolean,
        public showEmail: boolean,
        public showMobile: boolean,
        public showGuestName: boolean,
        public showGuestCompany: boolean,
        public showGuestAddress: boolean,
        public showGuestEmail: boolean,
        public showGuestMobile: boolean,
        public requiredName: boolean,
        public requiredCompany: boolean,
        public requiredAddress: boolean,
        public requiredEmail: boolean,
        public requiredMobile: boolean,
        public requiredGuestName: boolean,
        public requiredGuestCompany: boolean,
        public requiredGuestAddress: boolean,
        public requiredGuestEmail: boolean,
        public requiredGuestMobile: boolean,
        public fieldConfigurations: IFieldConfiguration[],
        public customFields: ICustomField[],
        public languages: ILanguage[],
        public contents: any,
        public showJobTitle: boolean,
        public showGuestJobTitle: boolean,
        public requiredJobTitle: boolean,
        public requiredGuestJobTitle: boolean,
        public fieldOrders: IFieldOrder[],
        public showCustomerNumber: boolean,
        public requiredCustomerNumber: boolean,
        public showGuestCustomerNumber: boolean,
        public requiredGuestCustomerNumber: boolean,
        public defaultGuests: number,
        public maximumGuests: number,
        public showLogo: boolean,
        public showBanner: boolean,
        public showDetail: boolean,
        public showContact: boolean,
        public routingPerVenue: boolean,
        public locationDateTimeEventPageFields: ILocationDateTimeEventPageField[],
        public pageLayoutType: PageLayoutType,
        public titles: any,
        public overrideGuests: boolean,
        public toDateDays: number,
        public overridePrivacyContent: boolean,
        public eventPrivacyContents: any,
        public overrideEmployeesDisclaimerContent: boolean,
        public overrideBusinessRelationsDisclaimerContent: boolean,
        public eventDisclaimerContents: EventDisclaimerContent[]
    ) { }
}

export interface IUpdateEventPage {
    type: EventPageType;
    id: string;
    fromDate: Date;
    toDate: Date;
    showName: boolean;
    showCompany: boolean;
    showAddress: boolean;
    showEmail: boolean;
    showMobile: boolean;
    showGuestName: boolean;
    showGuestCompany: boolean;
    showGuestAddress: boolean;
    showGuestEmail: boolean;
    showGuestMobile: boolean;
    requiredName: boolean;
    requiredCompany: boolean;
    requiredAddress: boolean;
    requiredEmail: boolean;
    requiredMobile: boolean;
    requiredGuestName: boolean;
    requiredGuestCompany: boolean;
    requiredGuestAddress: boolean;
    requiredGuestEmail: boolean;
    requiredGuestMobile: boolean;
    customFields: ICustomField[];
    customFieldsToDelete: string[];
    contents: any;
    showJobTitle: boolean;
    showGuestJobTitle: boolean;
    requiredJobTitle: boolean;
    requiredGuestJobTitle: boolean;
    fieldOrders: IFieldOrder[];
    baseFieldsToDelete: string[];
    showCustomerNumber: boolean;
    requiredCustomerNumber: boolean;
    showGuestCustomerNumber: boolean;
    requiredGuestCustomerNumber: boolean;
    defaultGuests: number;
    maximumGuests: number;
    showLogo: boolean;
    showBanner: boolean;
    showDetail: boolean;
    showContact: boolean;
    routingPerVenue: boolean;
    locationDateTimeEventPageFields: ILocationDateTimeEventPageField[];
    pageLayoutType: PageLayoutType;
    titles: any;
    overrideGuests: boolean;
    toDateDays: number;
    fieldLabels: IFieldLabel[];
    overridePrivacyContent: boolean;
    eventPrivacyContents: any;
    overrideEmployeesDisclaimerContent: boolean;
    overrideBusinessRelationsDisclaimerContent: boolean;
    eventDisclaimerContents: EventDisclaimerContent[];
}

export class UpdateEventPage implements IUpdateEventPage {
    constructor(
        public type: EventPageType,
        public id: string,
        public fromDate: Date,
        public toDate: Date,
        public showName: boolean,
        public showCompany: boolean,
        public showAddress: boolean,
        public showEmail: boolean,
        public showMobile: boolean,
        public showGuestName: boolean,
        public showGuestCompany: boolean,
        public showGuestAddress: boolean,
        public showGuestEmail: boolean,
        public showGuestMobile: boolean,
        public requiredName: boolean,
        public requiredCompany: boolean,
        public requiredAddress: boolean,
        public requiredEmail: boolean,
        public requiredMobile: boolean,
        public requiredGuestName: boolean,
        public requiredGuestCompany: boolean,
        public requiredGuestAddress: boolean,
        public requiredGuestEmail: boolean,
        public requiredGuestMobile: boolean,
        public customFields: ICustomField[],
        public customFieldsToDelete: string[],
        public contents: any,
        public showJobTitle: boolean,
        public showGuestJobTitle: boolean,
        public requiredJobTitle: boolean,
        public requiredGuestJobTitle: boolean,
        public fieldOrders: IFieldOrder[],
        public baseFieldsToDelete: string[],
        public showCustomerNumber: boolean,
        public requiredCustomerNumber: boolean,
        public showGuestCustomerNumber: boolean,
        public requiredGuestCustomerNumber: boolean,
        public defaultGuests: number,
        public maximumGuests: number,
        public showLogo: boolean,
        public showBanner: boolean,
        public showDetail: boolean,
        public showContact: boolean,
        public routingPerVenue: boolean,
        public locationDateTimeEventPageFields: ILocationDateTimeEventPageField[],
        public pageLayoutType: PageLayoutType,
        public titles: any,
        public overrideGuests: boolean,
        public toDateDays: number,
        public fieldLabels: IFieldLabel[],
        public overridePrivacyContent: boolean,
        public eventPrivacyContents: any,
        public overrideEmployeesDisclaimerContent: boolean,
        public overrideBusinessRelationsDisclaimerContent: boolean,
        public eventDisclaimerContents: EventDisclaimerContent[]
    ) { }
}

export interface IFieldOrder {
    id: string;
    customFieldId: string;
    fieldName: string;
    order: number;
    customFieldType: CustomFieldType;
    fieldGoToQuestion: number[];
    optionsGoToQuestion: IOptionsGoToQuestion[];
}

export class FieldOrder implements IFieldOrder {
    constructor(
        public id: string,
        public customFieldId: string,
        public fieldName: string,
        public order: number,
        public customFieldType: CustomFieldType,
        public fieldGoToQuestion: number[],
        public optionsGoToQuestion: IOptionsGoToQuestion[]
    ) { }
}

export interface ILocationDateTimeEventPageField {
    id: string;
    locationDateTimeId: string;
    goToQuestion: number[];
    text: string;
}

export interface IOptionsGoToQuestion {
    customFieldOptionId: string;
    index: number;
    goToQuestions: number[];
}

export interface ICustomField {
    id: string;
    contactCustomFieldId: string;
    translations: ICustomFieldTranslation[];
    show: boolean;
    showGuest: boolean;
    required: boolean;
    requiredGuest: boolean;
    customIdentifier: string;
    customFieldType: CustomFieldType;
    customFieldOptions: ICustomFieldOptions[];
    customFieldDocuments: ICustomFieldDocument[];
    customFieldConfigurations: ICustomFieldConfiguration[];
    freeTextFormat: FreeTextFormat;
    checkboxFormat: CheckboxFormat;
    selectFormat: SelectFormat;
    index: number;
    goToQuestion: number[];
    multipleChoiceConfigOptions: MultipleChoiceConfigOptions;
    optionsPerGroups: any;
}

export interface ICustomFieldTranslation {
    id: string;
    value: string;
    isDefault: boolean;
    languageId: string;
    label: string;
}

export class CustomFieldTranslation implements ICustomFieldTranslation {
    constructor(
        public id: string,
        public value: string,
        public isDefault: boolean,
        public languageId: string,
        public label: string
    ) { }
}

export interface ICustomFieldOptions {
    id: string;
    parentId: string;
    tempId: string;
    parentIndex: number;
    childrenIds: string[];
    contactCustomFieldOptionId: string;
    translations: ICustomFieldOptionsTranslation[];
    maxEntries: number;
    index: number;
    customIdentifier: string;
    goToQuestion: number[];
    entered: { };
    isDefault: boolean;
    timeSlot: DateTimeRange;
    eTicketName: string;
}
export class CustomFieldOptions implements ICustomFieldOptions {
    constructor(
        public id: string,
        public tempId: string,
        public parentId: string,
        public parentIndex: number,
        public childrenIds: string[],
        public contactCustomFieldOptionId: string,
        public translations: ICustomFieldOptionsTranslation[],
        public maxEntries: number,
        public index: number,
        public customIdentifier: string,
        public goToQuestion: number[],
        public entered: { },
        public isDefault: boolean,
        public timeSlot: DateTimeRange = null,
        public eTicketName: string = null,
    ) { }
}

export interface ICustomFieldDocument {
    id: string;
    customFieldId: string;
    documentId: string;
}

export class CustomFieldDocument {
    constructor(
        public id: string,
        public customFieldId: string,
        public documentId: string
    ) {}
}

export class DateTimeRange {

    static createForPeriod(period: ReportPeriodType): DateTimeRange {
        const toDate = moment(new Date());
        const jsToDate = toDate.toDate();
        let jsFromDate = toDate.toDate();
        if (period === ReportPeriodType.Last24Hour) {
          jsFromDate = toDate.add(0, 'days').toDate();
        }
        else if (period === ReportPeriodType.Last48Hour) {
          jsFromDate = toDate.add(-1, 'days').toDate();
        }
        else if (period === ReportPeriodType.LastWeek) {
          jsFromDate = toDate.add(-6, 'days').toDate();
        }
        else if (period === ReportPeriodType.Last2Weeks) {
          jsFromDate = toDate.add(-13, 'days').toDate();
        }
        else if (period === ReportPeriodType.LastMonth) {
          jsFromDate = toDate.add(-1, 'months').toDate();
        }
        else if (period === ReportPeriodType.Last3Month) {
          jsFromDate = toDate.add(-3, 'months').toDate();
        }
        else if (period === ReportPeriodType.Last6Month) {
          jsFromDate = toDate.add(-6, 'months').toDate();
        }
        else if (period === ReportPeriodType.LastYear) {
          jsFromDate = toDate.add(-1, 'years').toDate();
        }
        return new DateTimeRange(jsFromDate, jsToDate);
    }

    get isWithinASingleDay(): boolean {
        return this.begin.toLocaleDateString() === this.end.toLocaleDateString();
    };
    get isWithinASingleMonth(): boolean {
        return this.begin.getMonth() === this.end.getMonth();
    };
    get isWithinASingleYear(): boolean {
        return this.begin.getFullYear() === this.end.getFullYear();
    };

    constructor(public begin: Date, public end: Date) {
    }

    public format(language: string, venueTime: DateTimeRange): string {
        // single day event
        if(venueTime.isWithinASingleDay) {
            return `${moment(this.begin).format('LT')} - ${moment(this.end).format('LT')}`; // 19:00 - 20:00
        }
        // 1+day-event
        if (this.isWithinASingleDay && this.isWithinASingleMonth && this.isWithinASingleYear) {
            return `${moment(this.begin).format('dddd D MMMM')}, ${moment(this.begin).format('LT')} - ${moment(this.end).format('LT')}`; //donderdag 4 maart, 19:00 - 20:00
        } else if (this.isWithinASingleMonth && this.isWithinASingleYear) {
            return `${moment(this.begin).format('dddd D MMMM LT')} - ${moment(this.end).format('dddd D MMMM LT')}`;  //donderdag 4 maart 19:00 - vrijdag maart 5 10:00
        } else if (this.isWithinASingleYear) {
            return `${moment(this.begin).format('dddd D MMMM LT')} - ${moment(this.end).format('dddd D MMMM LT')}`;  //donderdag 4 maart 19:00 - vrijdag 5 maart 10:00
        } else {
            return `${moment(this.begin).format('dddd D MMMM  YYYY LT')} - ${moment(this.end).format('dddd D MMMM YYYY LT')}`;  //donderdag 30 december 2020 19:00 - zaterdag 2 jan 2021 10:00
        }
    }
}

export interface ICustomFieldOptionsTranslation {
    id: string;
    value: string;
    isDefault: boolean;
    languageId: string;
}

export class CustomFieldOptionsTranslation implements ICustomFieldOptionsTranslation {
    constructor(
        public id: string,
        public value: string,
        public isDefault: boolean,
        public languageId: string
    ) { }
}
export interface IFieldLabel {
    value: string;
    languageId: string;
    standardFieldType: number;
}

export class FieldLabel implements IFieldLabel {
    constructor(
        public value: string,
        public languageId: string,
        public standardFieldType: number
    ) { }
}
export interface IFieldConfiguration {
    isEditable: boolean;
    isVisible: boolean;
    standardFieldType?: StandardFieldType;
    registrationPageType: RegistrationPageType;
}

export class FieldConfiguration {
    constructor(
        public isEditable: boolean,
        public isVisible: boolean,
        public standardFieldType: StandardFieldType,
        public registrationPageType: RegistrationPageType
    ) { }
}

export interface ICustomFieldConfiguration {
    isEditable: boolean;
    isVisible: boolean;
    registrationPageType: RegistrationPageType;
}

export class CustomFieldConfiguration implements ICustomFieldConfiguration{
    constructor(
        public isEditable: boolean,
        public isVisible: boolean,
        public registrationPageType: RegistrationPageType
    ) { }
}

export class EventDisclaimerContent {
    constructor(
        public value: string,
        public languageId: string,
        public contactType: ContactType
    ){}
}
